import openSocket from 'socket.io-client';

const socket = openSocket('https://twitterimporter.plugin.vlogr.com', {
  withCredentials: false,
  transports: ['websocket'],
});

function subscribeToTimer(id, callback) {
  socket.on(id, (progress_state, progress) =>
    callback(null, progress_state, progress)
  );
  //socket.emit('subscribeToTimer', 0);
}

function sendForm(jsonObject) {
  socket.emit('client-event', JSON.stringify(jsonObject));
}

function validateURL(jsonObject) {
  socket.emit('validation_event', JSON.stringify(jsonObject));
}

function removeListeners() {
  socket.removeAllListeners();
}

export { subscribeToTimer };
export { sendForm };
export { validateURL };
export { removeListeners };
